import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import RegularButton from "../../components/Buttons/RegularButton";
import { useNavigate } from "react-router-dom";
import { useCompleteBookingDetailMutation } from "../../redux/services/bookingApi";
import { useSaveAuditLogMutation } from "../../redux/services/calculateBillingRateService";
import MuiAlert from "../MuiAlert/MuiAlert";

function ExtraPaymentSuccess() {
  const navigate = useNavigate();
  const [completeBookingDetail, completeBookingDetailResponse] =
    useCompleteBookingDetailMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  const value = JSON.parse(localStorage.getItem("extraPaymentBooking") || "{}");
  const [auditLog, auditLogResponse] = useSaveAuditLogMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  useEffect(() => {
    completeBookingDetail({
      token: userToken,
      payload: value,
    });
    auditLog({
      payload: {
        endTime: new Date(),
        eventName: "WEB",
        request: JSON.stringify(value),
        response: JSON.stringify(completeBookingDetailResponse),
        serviceName: "EXTRA_PAYMENT_BOOKING_START",
        startTime: new Date(),
        url: "/bookingDetail/complete",
      },
    });
  }, []);

  useEffect(() => {
    if (completeBookingDetailResponse.isError) {
      setStatusCode({ type: "error", code: "PAYMENT_FAILURE" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 10000);
    }
    if (completeBookingDetailResponse.isSuccess) {
      localStorage.removeItem("extraPaymentBooking");
      setStatusCode({ type: "error", code: "PAYMENT_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 10000);
      auditLog({
        payload: {
          endTime: new Date(),
          eventName: "WEB",
          request: {},
          response: JSON.stringify(completeBookingDetailResponse),
          serviceName: "EXTRA_PAYMENT_BOOKING_COMPLETE",
          startTime: new Date(),
          url: "/bookingDetail/complete",
        },
      });
      navigate("/");
    }
  }, [
    completeBookingDetailResponse.isError,
    completeBookingDetailResponse.isSuccess,
  ]);

  return (
    <div className="overscroll-x-none">
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>

      {isAlertVisible && (
        <div>
          <MuiAlert
            severity={statusCode?.type!}
            messageType={statusCode?.code!}
          />
        </div>
      )}

      <div className="mx-[200px] my-[150px] ">
        <div
          className=" justify-center  rounded-[4px]  h-[20%]  shadow-2xl "
          style={{
            overflow: "hidden",
            marginBottom: 10,
            zIndex: -1,
            backgroundColor: "white",
          }}
        >
          <div className="justify-between items-center flex flex-col  ">
            <h5 className="text-3xl pt-4 mr-8 ml-8">Payment sucessful</h5>
            <RegularButton
              onClick={() => {
                navigate("/");
              }}
              className=" md:w-[30%] p-4 m-2"
              title={"Go home"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtraPaymentSuccess;
